import {
  createMedioDeContacto,
  listAllMediosDeContacto,
  softDeleteMedioDeContacto,
  updateMedioDeContacto,
  type MediosDeContactoFields,
} from '@/shared/api/controllers/mediosContacto';
import { SimpleAbmEntity, type SimpleAbmAdapter } from '../../SimpleAbmEntity';
import type { EntityViewProps } from '../../types';

const adapter: SimpleAbmAdapter<MediosDeContactoFields> = {
  queryKey: ['configuracion', 'medios-contacto'],
  abmKind: 'medios-contacto',
  listAll: listAllMediosDeContacto,
  create: createMedioDeContacto,
  update: updateMedioDeContacto,
  softDelete: softDeleteMedioDeContacto,
  valueOf: (i) => i.fields.Medio_MC ?? '',
  statusOf: (i) => i.fields.Status_MC,
  fieldLabel: 'Medio',
  fieldPlaceholder: 'Ingresar Medio',
  entitySingular: 'medio de contacto',
  createdMessage: 'Medio de contacto creado correctamente.',
  updatedMessage: 'Medio de contacto actualizado correctamente.',
  deletedMessage: 'Medio de contacto eliminado correctamente.',
};

export function MediosDeContactoEntity(props: EntityViewProps) {
  return <SimpleAbmEntity adapter={adapter} {...props} />;
}
